export default __webpack_public_path__ + "static/carousel3-327e8e273c2189eedac9ac027c8d9112.png";